<ng-container *ngIf="slide">
  <div class="slide-wrapper">
    <h2>
      {{ slide.title }}
    </h2>
    <p>
      {{ slide.description }}
    </p>
    <a class="carousel-slide-button" [href]="slide.route">
      Find out more
      <img src="assets/icons/primary_arrow_right.svg" />
    </a>
  </div>
</ng-container>
